module.exports = __webpack_public_path__ + "img/xxdt.b908c0e7.png";